module.exports = __webpack_public_path__ + "static/opener-6164d6a5062f74f3272341bc9595c413.jpg";